import React from 'react';
import {Link} from 'react-router-dom';
import dayjs from 'dayjs';
import _ from 'lodash';

import {DOCUMENTS, INDEX, LOGIN, REFUND} from '../../config/routes';
import bg from '../../images/gradient-01.jpg'
import logo from '../../images/logo_176x24.svg';
import {menuItems} from '../Header/Header';

import cls from './Footer.module.scss'

interface ILegal {
    name: string
    INN: string
    OGRN: string
}

export const policyItems = [
    {
        link: DOCUMENTS,
        label: 'Оферты и документы',
    },
    {
        link: LOGIN,
        label: 'Личный кабинет',
    },
    {
        link: REFUND,
        label: 'Расторгнуть договор',
    },
]

export const legalItems:ILegal[] = [
    // {
    //     name: 'ООО «ИТ Консул»',
    //     INN: '9724139250',
    //     OGRN: '1237700492204',
    // },
    // {
    //     name: 'ООО «ЭфТиЭс»',
    //     INN: '9707022044',
    //     OGRN: '1237700933733',
    // },
]

const Footer = () => {

    const year = dayjs().year()

    return (
        <div className={cls.footer} style={{backgroundImage: `url(${bg})`}}>
            <div className={cls.content}>
                <div className={cls.logo}>
                    <Link to={INDEX}>
                        <img src={logo} alt={'logo'}/>
                    </Link>
                </div>
                <div className={cls.wrap}>
                    <div className={cls.caption}>
                        <p>© ФТС Группа Компаний 2021–{year}</p>
                        <p>Все права защищены</p>
                    </div>
                    <div className={cls.menu}>
                        {_.map(menuItems, item => (
                            <p key={item.link}><Link to={item.link}>{item.label}</Link></p>
                        ))}
                    </div>
                    <div className={cls.policy}>
                        {_.map(policyItems, item => (
                            <p key={item.link}><Link to={item.link}>{item.label}</Link></p>
                        ))}
                    </div>
                    {_.map(legalItems, item => (
                        <div key={item.INN} className={cls.legal}>
                            <p>{item.name}</p>
                            <p>ИНН {item.INN}</p>
                            <p>ОГРН {item.OGRN}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Footer